import React, { useState, useEffect, useCallback } from 'react';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { formatRupiah } from '../../utils/Formatter';
import '../../pages/ProfilePage/ProfilePage.css'; // Pastikan path ini benar
import { FaImage } from 'react-icons/fa';

const OrderDetail = ({ order, API_URL }) => (
    <div className="order-detail">
        <p><strong>Total Pesanan:</strong> {formatRupiah(order.totalAmount)}</p>
        <p><strong>Metode:</strong> {order.deliveryMethod}</p>
        <h5>Barang yang dipesan:</h5>
        <ul>
            {order.OrderItems.map(item => (
                <li key={item.id}>
                    {/* --- PERBAIKAN 2: Mengambil gambar dari relasi BarangImages --- */}
                    {item.Product?.Barang?.BarangImages && item.Product.Barang.BarangImages.length > 0 ? (
                        <img 
                            src={`${API_URL}/${item.Product.Barang.BarangImages[0].imageUrl}`} 
                            alt={item.Product.Barang.nama_barang} 
                            className="item-thumbnail"
                        />
                    ) : (
                        <div className="item-thumbnail item-thumbnail-placeholder">
                            <FaImage />
                        </div>
                    )}
                    
                    <div className="item-info">
                        {/* --- PERBAIKAN 1: Menggunakan 'Merek' (huruf besar) --- */}
                        <span className="item-brand">{item.Product?.Barang?.Merek?.nama_merek}</span>
                        <span className="item-name">
                            {item.Product?.Barang?.nama_barang || '[Produk Dihapus]'} ({item.Product?.nama_satuan || 'N/A'})
                        </span>
                    </div>
                    <span className="item-quantity">(x{item.quantity})</span>
                </li>
            ))}
        </ul>
    </div>
);

const OrderHistory = () => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [expandedOrderId, setExpandedOrderId] = useState(null);
    const [filterStatus, setFilterStatus] = useState('');

    const API_URL = api.defaults.baseURL.replace('/api', '');

    const fetchUserOrders = useCallback(async () => {
        setLoading(true);
        try {
            const { data } = await api.get('/orders/my-orders', {
                params: {
                    status: filterStatus || undefined
                }
            }); 
            setOrders(data.orders);
        } catch (error) { 
            console.error("Gagal mengambil riwayat pesanan:", error);
            toast.error("Gagal memuat riwayat pesanan.");
        } finally {
            setLoading(false);
        }
    }, [filterStatus]);

    useEffect(() => {
        fetchUserOrders();
    }, [fetchUserOrders]);

    const formatDate = (dateString) => new Date(dateString).toLocaleDateString('id-ID', {
        day: '2-digit', month: 'long', year: 'numeric'
    });

    const toggleOrderDetail = (orderId) => {
        setExpandedOrderId(prevId => (prevId === orderId ? null : orderId));
    };

    return (
        <div className="tab-content">
            <h2>Riwayat Pesanan Saya</h2>

            <div className="order-filter-buttons">
                <button onClick={() => setFilterStatus('')} className={!filterStatus ? 'active' : ''}>Semua</button>
                <button onClick={() => setFilterStatus('diproses')} className={filterStatus === 'diproses' ? 'active' : ''}>Diproses</button>
                <button onClick={() => setFilterStatus('diantar')} className={filterStatus === 'diantar' ? 'active' : ''}>Dikirim</button>
                <button onClick={() => setFilterStatus('selesai')} className={filterStatus === 'selesai' ? 'active' : ''}>Selesai</button>
                <button onClick={() => setFilterStatus('dibatalkan')} className={filterStatus === 'dibatalkan' ? 'active' : ''}>Dibatalkan</button>
            </div>

            <div className="orders-history-container">
                {loading ? (
                    <p className="loading-message">Memuat pesanan...</p>
                ) : orders.length > 0 ? (
                    orders.map(order => (
                        <div key={order.id} className="order-item">
                            <div className="order-summary" onClick={() => toggleOrderDetail(order.id)}>
                                <div className="summary-info">
                                    <span>Pesanan #{order.id.substring(0, 8)}</span>
                                    <span className="summary-date">{formatDate(order.createdAt)}</span>
                                </div>
                                <div className="summary-status">
                                    <span className={`status-badge ${order.status}`}>{order.status}</span>
                                    <span className={`arrow ${expandedOrderId === order.id ? 'up' : 'down'}`}>▼</span>
                                </div>
                            </div>
                            {expandedOrderId === order.id && <OrderDetail order={order} API_URL={API_URL} />}
                        </div>
                    ))
                ) : (
                    <p>Tidak ada pesanan dengan status ini.</p>
                )}
            </div>
        </div>
    );
};

export default OrderHistory;